export default [
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login-v2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
      redirectIfLoggedIn: true,
    },
  },

  // Dashboard
  {
    path: '/apps/fbr-invoice',
    name: 'dashboard',
    component: () => import('@/views/apps/fbr-invoice/dashboard/Dashboard.vue'),
    meta: {
      pageTitle: 'FBR Invoice Dashboard',
      browserTitle: 'FBR Invoice Dashboard',
      authRoute: 'dashboard',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },

  /**
   {
        "id": 84,
        "businessID": 4,
        "groupID": 14,
        "name": "Dashboard",
        "sequence": 0,
        "icon": "-",
        "route": "fbr-invoice-dashboard",
        "status": "active"
    }
   */

  {
    path: '/apps/fbr-invoice/unit-of-measure',
    name: 'unit-of-measure',
    component: () => import('@/views/apps/fbr-invoice/unit-of-measure/UOMList.vue'),
    meta: {
      pageTitle: 'Unit of Measure',
      browserTitle: 'Unit of Measure',
      authRoute: 'unit-of-measure',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Inventory',
          active: false,
        },
        {
          text: 'Unit of Measure',
          active: true,
        },
      ],
    },
  },

  {
    path: '/apps/fbr-invoice/item-group',
    name: 'item-group',
    component: () => import('@/views/apps/fbr-invoice/item-group/ItemGroupList.vue'),
    meta: {
      pageTitle: 'Item Group',
      browserTitle: 'Item Group',
      authRoute: 'item-group',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Inventory',
          active: false,
        },
        {
          text: 'Item Group',
          active: true,
        },
      ],
    },
  },

  {
    path: '/apps/fbr-invoice/hs-code',
    name: 'hscode',
    component: () => import('@/views/apps/fbr-invoice/hs-code/HSCodeList.vue'),
    meta: {
      pageTitle: 'HS Code',
      browserTitle: 'HS Code',
      authRoute: 'hscode',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Inventory',
          active: false,
        },
        {
          text: 'HS Code',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/customer',
    name: 'customer',
    component: () => import('@/views/apps/fbr-invoice/customer/CustomerList.vue'),
    meta: {
      pageTitle: 'Customer',
      browserTitle: 'Customer',
      authRoute: 'customer',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Inventory',
          active: false,
        },
        {
          text: 'Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/customer/add',
    name: 'customer-add',
    component: () => import('@/views/apps/fbr-invoice/customer/CustomerAdd.vue'),
    meta: {
      pageTitle: 'Add Customer',
      browserTitle: 'Add Customer',
      authRoute: 'customer-add',
      permissionKey: 'add',
      breadcrumb: [
        {
          text: 'Customer',
          active: false,
          to: '/apps/fbr-invoice/customer',
        },
        {
          text: 'Add Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/customer/edit/:id',
    name: 'customer-edit',
    component: () => import('@/views/apps/fbr-invoice/customer/CustomerEdit.vue'),
    props: true,
    meta: {
      pageTitle: 'Edit Customer',
      browserTitle: 'Edit Customer',
      authRoute: 'customer-edit',
      permissionKey: 'edit',
      breadcrumb: [
        {
          text: 'Customer',
          active: false,
          to: '/apps/fbr-invoice/customer',
        },
        {
          text: 'Edit Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/customer/view/:id',
    name: 'customer-view',
    component: () => import('@/views/apps/fbr-invoice/customer/CustomerView.vue'),
    props: true,
    meta: {
      pageTitle: 'View Customer',
      browserTitle: 'View Customer',
      authRoute: 'customer-view',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Customer',
          active: false,
          to: '/apps/fbr-invoice/customer',
        },
        {
          text: 'View Customer',
          active: true,
        },
      ],
    },
  },

  // ====== sub categories ====
  {
    path: '/apps/fbr-invoice/sub-categories',
    name: 'sub-categories',
    component: () => import('@/views/apps/fbr-invoice/sub-categories/SubCategoryList.vue'),
    meta: {
      pageTitle: 'Sub Categories',
      browserTitle: 'Sub Categories',
      authRoute: 'sub-categories',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Customer',
          active: false,
        },
        {
          text: 'Sub Categories',
          active: true,
        },
      ],
    },
  },

  {
    path: '/apps/fbr-invoice/sales-type',
    name: 'sales-type',
    component: () => import('@/views/apps/fbr-invoice/sales-type/SalesTypeList.vue'),
    meta: {
      pageTitle: 'Sales Type',
      browserTitle: 'Sales Type',
      authRoute: 'sales-type',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Inventory',
          active: false,
        },
        {
          text: 'Sales Type',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/items',
    name: 'item',
    component: () => import('@/views/apps/fbr-invoice/items/ItemsList.vue'),
    meta: {
      pageTitle: 'Items',
      browserTitle: 'Items',
      authRoute: 'items',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Inventory',
          active: false,
        },
        {
          text: 'Items',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/items/add',
    name: 'items-add',
    component: () => import('@/views/apps/fbr-invoice/items/ItemsAdd.vue'),
    meta: {
      pageTitle: 'Add Item',
      browserTitle: 'Add Item',
      authRoute: 'items-add',
      permissionKey: 'add',
      breadcrumb: [
        {
          text: 'Items',
          active: false,
          to: '/apps/fbr-invoice/items',
        },
        {
          text: 'Add Item',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/items/edit/:id',
    name: 'items-edit',
    component: () => import('@/views/apps/fbr-invoice/items/ItemsEdit.vue'),
    props: true,
    meta: {
      pageTitle: 'Edit Item',
      browserTitle: 'Edit Item',
      authRoute: 'items-edit',
      permissionKey: 'edit',
      breadcrumb: [
        {
          text: 'Items',
          active: false,
          to: '/apps/fbr-invoice/items',
        },
        {
          text: 'Edit Item',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/items/view/:id',
    name: 'items-view',
    component: () => import('@/views/apps/fbr-invoice/items/ItemsView.vue'),
    props: true,
    meta: {
      pageTitle: 'View Item',
      browserTitle: 'View Item',
      authRoute: 'items-view',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Items',
          active: false,
          to: '/apps/fbr-invoice/items',
        },
        {
          text: 'View Item',
          active: true,
        },
      ],
    },
  },

  // Sales Invoice
  {
    path: '/apps/fbr-invoice/sales-invoice',
    name: 'sales-invoice',
    component: () => import('@/views/apps/fbr-invoice/sales-invoice/invoice-list/InvoiceList.vue'),
    meta: {
      pageTitle: 'Sales Invoice',
      browserTitle: 'Sales Invoice',
      authRoute: 'sales-invoice',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Sales Invoice',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/sales-invoice/add',
    name: 'sales-invoice-add',
    component: () => import('@/views/apps/fbr-invoice/sales-invoice/invoice-add/InvoiceAdd.vue'),
    meta: {
      pageTitle: 'Sales Invoice Add',
      browserTitle: 'Sales Invoice Add',
      authRoute: 'sales-invoice-add',
      permissionKey: 'add',
      breadcrumb: [
        {
          text: 'Sales Invoice',
          active: false,
          to: '/apps/fbr-invoice/sales-invoice',
        },
        {
          text: 'Sales Invoice Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/sales-invoice/edit/:id',
    name: 'sales-invoice-edit',
    component: () => import('@/views/apps/fbr-invoice/sales-invoice/invoice-edit/InvoiceEdit.vue'),
    meta: {
      pageTitle: 'Sales Invoice Edit',
      browserTitle: 'Sales Invoice Edit',
      authRoute: 'sales-invoice-edit',
      permissionKey: 'edit',
      breadcrumb: [
        {
          text: 'Sales Invoice',
          active: false,
          to: '/apps/fbr-invoice/sales-invoice',
        },
        {
          text: 'Sales Invoice Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/sales-invoice/view/:id',
    name: 'sales-invoice-view',
    component: () =>
      import('@/views/apps/fbr-invoice/sales-invoice/invoice-preview/InvoicePreview.vue'),
    meta: {
      pageTitle: 'Sales Invoice View',
      browserTitle: 'Sales Invoice View',
      authRoute: 'sales-invoice-view',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Sales Invoice',
          active: false,
          to: '/apps/fbr-invoice/sales-invoice',
        },
        {
          text: 'Sales Invoice View',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/sales-invoice/print/:id',
    name: 'sales-invoice-print',
    component: () =>
      import('@/views/apps/fbr-invoice/sales-invoice/invoice-print/InvoicePrint.vue'),
    meta: {
      pageTitle: 'Invoice Print',
      browserTitle: 'Invoice Print',
      authRoute: 'sales-invoice',
      permissionKey: 'view',
      layout: 'full',
    },
  },

  // User Management
  {
    path: '/apps/fbr-invoice/users',
    name: 'users',
    component: () => import('@/views/apps/fbr-invoice/user-management/users-list/UsersList.vue'),
    meta: {
      pageTitle: 'Users',
      browserTitle: 'Users',
      authRoute: 'users',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Users',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/roles',
    name: 'roles',
    component: () => import('@/views/apps/fbr-invoice/roles/RolesList.vue'),
    meta: {
      pageTitle: 'Roles',
      browserTitle: 'Roles',
      authRoute: 'roles',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Roles',
          active: true,
        },
      ],
    },
  },

  // Business Management
  {
    path: '/apps/fbr-invoice/business-management',
    name: 'fbr-business-management',
    component: () => import('@/views/apps/fbr-invoice/business-management/Business.vue'),
    meta: {
      pageTitle: 'Business Management',
      browserTitle: 'Business Management - FBR Invoice',
      authRoute: 'fbr-business-management',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'FBR Invoice',
        },
        {
          text: 'Business Management',
          active: true,
        },
      ],
    },
  },

  // Business
  {
    path: '/apps/fbr-invoice/business/add',
    name: 'business-add',
    component: () => import('@/views/apps/fbr-invoice/dashboard/business/BusinessAdd.vue'),
    meta: {
      pageTitle: 'Add Business',
      browserTitle: 'Add Business',
      authRoute: 'business-add',
      permissionKey: 'add',
      breadcrumb: [
        {
          text: 'Add Business',
          active: true,
        },
      ],
    },
  },

  // ====== Reports ======
  {
    path: '/apps/fbr-invoice/reports/customer-report',
    name: 'fbr-customer-report',
    component: () => import('@/views/apps/fbr-invoice/reports/CustomerReport.vue'),
    meta: {
      pageTitle: 'Customer Report',
      browserTitle: 'Customer Report - FBR Invoice',
      authRoute: 'fbr-customer-report',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Reports',
        },
        {
          text: 'Customer Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/reports/items-report',
    name: 'fbr-items-report',
    component: () => import('@/views/apps/fbr-invoice/reports/ItemsReport.vue'),
    meta: {
      pageTitle: 'Items Report',
      browserTitle: 'Items Report - FBR Invoice',
      authRoute: 'fbr-items-report',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Reports',
        },
        {
          text: 'Items Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/reports/sales-invoice-report',
    name: 'fbr-sales-invoice-report',
    component: () => import('@/views/apps/fbr-invoice/reports/SalesInvoiceReport.vue'),
    meta: {
      pageTitle: 'Sales Invoice Report',
      browserTitle: 'Sales Invoice Report - FBR Invoice',
      authRoute: 'fbr-sales-invoice-report',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Reports',
        },
        {
          text: 'Sales Invoice Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/reports/sales-invoice-summary-report',
    name: 'fbr-sales-invoice-summary-report',
    component: () => import('@/views/apps/fbr-invoice/reports/SalesInvoiceSummaryReport.vue'),
    meta: {
      pageTitle: 'Sales Invoice Summary Report',
      browserTitle: 'Sales Invoice Summary Report - FBR Invoice',
      authRoute: 'fbr-sales-invoice-summary-report',
      permissionKey: 'view',
      breadcrumb: [
        {
          text: 'Reports',
        },
        {
          text: 'Sales Invoice Summary Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/fbr-invoice/sales-invoice/monthly-summary-report',
    name: 'fbr-monthly-summary-report',
    component: () => import('@/views/apps/fbr-invoice/sales-invoice/invoice-list/MonthlySummaryReportPrint.vue'),
    meta: {
      pageTitle: 'Monthly Summary Report',
      browserTitle: 'Monthly Summary Report',
      authRoute: 'sales-invoice',
      permissionKey: 'view',
      layout: 'full',
    },
  },
];
